import failIcon from "assets/icon/NO.svg";
import successIcon from "assets/icon/success.svg";
import AddressSearchModal from "components/AddressSearchModal/AddressSearchModal";
import IconButton from "components/Button/IconButton";
import {
  contentTypeJson,
  getCurrentDate,
  getPermission,
  restEmpty,
  simpleAlert,
} from "components/CommonLib/CommonLib";
import ComboBox from "components/LabelInput/ComboBox";
import DatePicker from "components/LabelInput/DatePicker";
import Label from "components/LabelInput/Label";
import SearchComboBox from "components/LabelInput/SearchComboBox";
import TextField from "components/LabelInput/TextField";
import Loading from "components/Loading/Loading/Loading";
import ModalPopupLocal from "components/ModalPopup/ModalPopupLocal";
import Popup from "components/ModalPopup/Popup";
import NormalBtn from "components/NewButton/NormalBtn";
import SubTitle from "components/PageTitle/SubTitle";
import { doc, onSnapshot } from "firebase/firestore";
import { HttpInstance } from "lib/HttpLib";
import _ from "lodash";
import { globalAlertOn } from "modules/actions/Alert";
import RegisterPhoneCheckModal from "pages/ERP/MemberRegister/Register/Modal/RegisterPhoneCheckModal";
import { useEffect, useRef, useState } from "react";
import DaumPostcode from "react-daum-postcode";
import { useDispatch } from "react-redux";
import { db } from "../../../../../firebase";

const AssignNewbie = ({ modalParam, onModalDone, setSearchParam }) => {
  const storesDispatch = useDispatch();
  const labelWidth = "4rem";
  const compWidth = "10rem";
  const [loading, setLoading] = useState(false);
  const [isAddrPopup, setAddrPopup] = useState(false);
  const [isUseJusoApi, setIsUseJusoApi] = useState(false);
  const [createdMemberId, setCreatedMemberId] = useState("");

  const [hqIdx, setHqIdx] = useState(0);
  let [phone1, setPhone1] = useState("");
  let [phone2, setPhone2] = useState("");
  let [phone3, setPhone3] = useState("");
  const phoneRef1 = useRef();
  const phoneRef2 = useRef();
  const phoneRef3 = useRef();
  const [phoneCheckStatus, setPhoneCheckStatus] = useState("");
  const [removePhoneMemberId, setRemovePhoneMemberId] = useState("");

  // 상담자 정보 State 추가
  const [csStaffState, setCsStaffState] = useState({
    cs_team_name_list: [],
    cs_team_list: {
      key: "",
      branch_id: "",
      branch_name: "",
      team: [],
    },
  });

  const [hqBranchData, setHqBranchData] = useState({
    branch_list: [[]],
    hq_list: [],
    target_list: [],
  });

  const [memberInfo, setMemberInfo] = useState({
    access: {
      access_method: "",
      card_no: "",
    },
    active_info: {},
    base_info: {
      agree_marketing: false,
      agree_personal: false,
      ages: "",
      gender: "남",
      phone: "",
      address_1: "",
      address_2: "",
      birth: "",
      remarks: "",
    },
    branch_info: {
      branch_id: "",
      branch_name: "",
    },
    branch_pt_detail: {},

    hq_info: {
      hq_id: "",
      hq_name: "",
    },
    member_info: {
      member_id: "000000000000000000000000",
      member_name: "",
      member_no: "",
    },
    member_type: "",
    cs_staff_info: {
      // 추가
      staff_id: "",
      sabun: "",
      staff_name: "",
      staff_pos: "",
      staff_rank: "",
    },
  });

  const viewModelRef = useRef();
  const [modalInfo, setModalInfo] = useState({
    show: false,
    title: "",
    Content: "",
    callback: null,
    Buttons: undefined,
  });

  // 생년월일로부터 연령대 계산
  const calculateAgeGroup = (birthDate) => {
    if (!birthDate) return "";

    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    // 생일이 아직 안 지났으면 -1
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }

    if (age < 30) return "10~20대";
    if (age < 40) return "30대";
    if (age < 50) return "40대";
    return "50대 이상";
  };

  const validationCheck = () => {
    if (!memberInfo.member_info.member_name) {
      simpleAlert(storesDispatch, "알림", "이름을 입력해주세요.");
    } else if (!memberInfo.base_info.reg_path) {
      simpleAlert(storesDispatch, "알림", "가입경로를 입력해주세요.");
    } else if (!memberInfo.base_info.ages) {
      simpleAlert(storesDispatch, "알림", "연령대을 선택해주세요.");
    } else if (!memberInfo.base_info.birth) {
      simpleAlert(storesDispatch, "알림", "생년월일을 입력해주세요.");
    } else if (!memberInfo.base_info.gender) {
      simpleAlert(storesDispatch, "알림", "성별을 선택해주세요.");
    } else if (!memberInfo.base_info.phone) {
      simpleAlert(storesDispatch, "알림", "연락처를 입력해주세요.");
    } else if (!memberInfo.cs_staff_info.staff_id) {
      simpleAlert(storesDispatch, "알림", "상담자를 선택해주세요.");
    } else if (!memberInfo.base_info.address_1) {
      simpleAlert(storesDispatch, "알림", "주소를 입력해주세요.");
    } else {
      // 주소 검증 제거됨
      storesDispatch(
        globalAlertOn({
          show: true,
          titleText: "알림",
          bodyText: <Label labelText="입력된 정보로 회원 등록을 진행합니다." />,
          onBtnYes: () => {
            createGuestAndConvert();
          },
          onBtnNo: () => {},
        }),
      );
    }
  };

  // 주소 팝업 열기
  const openAddrPopup = (val) => {
    setAddrPopup(val);
  };

  // 다음 주소 선택 핸들러
  const handleComplete = (data) => {
    openAddrPopup(false);
    setMemberInfo((cur) => {
      const obj = { ...cur };
      obj.base_info.address_1 = data.address;
      return obj;
    });
  };

  // 행정안전부 주소 선택 핸들러
  const handleJusoSelect = (addressData) => {
    setMemberInfo((cur) => {
      const obj = { ...cur };
      obj.base_info.address_1 = addressData.roadAddr;
      return obj;
    });
    setAddrPopup(false);
  };

  const createGuestAndConvert = async () => {
    try {
      setLoading(true);

      // 전화번호 기존 소유자가 있으면 삭제
      if (removePhoneMemberId) {
        await HttpInstance.patch(
          process.env.REACT_APP_USER_SERVER + "/member_info/delete_phone",
          "",
          {
            params: {
              member_id: removePhoneMemberId,
              phone: memberInfo.base_info.phone,
            },
          },
        );
      }

      // 현재 날짜와 시간
      const now = new Date();
      const currentDate = now.toISOString().split("T")[0]; // YYYY-MM-DD
      const currentTime = now.toTimeString().split(" ")[0].substring(0, 5); // HH:MM

      // 고객 생성 (방명록)
      const guestBookData = {
        hq_info: memberInfo.hq_info,
        branch_info: memberInfo.branch_info,
        member_name: memberInfo.member_info.member_name,
        phone: memberInfo.base_info.phone,
        gender: memberInfo.base_info.gender,
        ages: memberInfo.base_info.ages,
        visit_path: memberInfo.base_info.reg_path || "기타",
        cs_date: currentDate,
        cs_time: currentTime,
        inquiry_title: "기타 (직접 입력)",
        inquiry_memo: "양도 신규 등록",
        cs_staff_info: memberInfo.cs_staff_info,
        agree_marketing: false,
        agree_personal: false,
        cs_type: "방명록",
        is_trans_member: false,
        member_id: "",
      };

      const guestFormData = new FormData();
      guestFormData.append("new_info", JSON.stringify(guestBookData));

      const guestRes = await HttpInstance.post(
        process.env.REACT_APP_USER_SERVER + "/cs/guest_book/add",
        guestFormData,
        contentTypeJson,
      );
      if (guestRes.data.msg) {
        simpleAlert(storesDispatch, "ERROR", guestRes.data.msg);
        return;
      }
      // 고객 등록 성공 후 검색으로 고객정보 획득
      const searchParam = {
        hq_info: memberInfo.hq_info,
        branch_info: memberInfo.branch_info,
        member_info: {
          member_name: memberInfo.member_info.member_name,
          member_no: "",
        },
        base_info: {
          phone: memberInfo.base_info.phone,
        },
      };

      const searchFormData = new FormData();
      searchFormData.append("page_num", 1);
      searchFormData.append("search_param", JSON.stringify(searchParam));

      const searchRes = await HttpInstance.post(
        process.env.REACT_APP_USER_SERVER + "/member/search_modal",
        searchFormData,
        contentTypeJson,
      );

      if (searchRes.data.msg || !searchRes.data.data || searchRes.data.data.length === 0) {
        simpleAlert(storesDispatch, "ERROR", "등록된 고객을 찾을 수 없습니다.");
        return;
      }

      // 검색 결과에서 첫 번째 (방금 등록한 고객)
      const newMember = searchRes.data.data[0];
      const newMemberId = newMember.member_info.member_id;

      // 🆕 즉시 회원전환 진행
      const convertData = {
        member_type: "회원",
        branch_info: memberInfo.branch_info,
        hq_info: memberInfo.hq_info,
        member_id: newMemberId,
        personal_info: {
          address_1: memberInfo.base_info.address_1,
          address_2: memberInfo.base_info.address_2,
          agree_marketing: memberInfo.base_info.agree_marketing,
          agree_personal: memberInfo.base_info.agree_personal,
          birth: memberInfo.base_info.birth,
          gender: memberInfo.base_info.gender,
          member_name: memberInfo.member_info.member_name,
          member_no: newMember.member_no || "", // 검색 결과에서 가져온 회원번호
          phone: memberInfo.base_info.phone,
          notice: memberInfo.base_info.remarks || "",
          email: "",
          phone_backup: "",
          reg_path: memberInfo.base_info.reg_path,
          zip_code: "",
        },
      };

      const convertFormData = new FormData();
      convertFormData.append("new_info", JSON.stringify(convertData));

      const convertRes = await HttpInstance.post(
        process.env.REACT_APP_USER_SERVER + "/member_type/edit",
        convertFormData,
        contentTypeJson,
      );

      if (convertRes.data.msg) {
        simpleAlert(storesDispatch, "ERROR", "회원전환 실패: " + convertRes.data.msg);
        return;
      }
      // 🆕 회원전환 후 최신 정보 다시 검색
      const finalSearchFormData = new FormData();
      finalSearchFormData.append("page_num", 1);
      finalSearchFormData.append("search_param", JSON.stringify(searchParam));

      const finalSearchRes = await HttpInstance.post(
        process.env.REACT_APP_USER_SERVER + "/member/search_modal",
        finalSearchFormData,
        contentTypeJson,
      );

      if (
        finalSearchRes.data.msg ||
        !finalSearchRes.data.data ||
        finalSearchRes.data.data.length === 0
      ) {
        simpleAlert(storesDispatch, "ERROR", "회원전환 후 회원 정보를 찾을 수 없습니다.");
        return;
      }

      // 🆕 검색 결과 그대로 사용 (AssigneeTable과 동일한 구조)
      const assigneeData = finalSearchRes.data.data[0];
      simpleAlert(
        storesDispatch,
        "알림",
        "신규 회원 등록이 완료되었습니다. 양도를 진행해주시기 바랍니다.",
        true,
        () => {
          // onModalDone("cancel");
          onModalDone("success", assigneeData);
        },
      );
    } catch (err) {
      console.log("고객 생성 오류:", err);
      simpleAlert(
        storesDispatch,
        "ERROR",
        err.response?.data?.msg || err.message || "처리 중 오류가 발생했습니다.",
      );
      onModalDone("cancel");
    } finally {
      setLoading(false);
    }
  };
  const getHqBranchCombo = async () => {
    const result = await getPermission(storesDispatch, "MEMBER_VIEW_MENU/MANAGE", true);
    setMemberInfo((cur) => {
      const hq_info = result.target_list[0].hq_info;
      const branch_info = result.target_list[0].branch_list[0];
      return { ...cur, hq_info, branch_info };
    });
    setHqBranchData(result);
    // 초기 지점의 CS 직원 목록 가져오기
    if (result.target_list[0]?.branch_list[0]?.branch_id) {
      getBranchCsStaffList(result.target_list[0].branch_list[0].branch_id);
    }
  };

  const getBranchCsStaffList = (branchId) => {
    if (branchId !== "") {
      HttpInstance.get(process.env.REACT_APP_STAFF_SERVER + "/cs/team/list", {
        params: {
          branch_id: branchId,
        },
      })
        .then((res) => {
          if (!restEmpty(res.data.data)) {
            const restData = res.data.data;
            setCsStaffState({
              cs_team_list: restData.cs_team_list,
              cs_team_name_list: restData.cs_team_name_list,
            });
          }
        })
        .catch((err) => {
          console.log("err");
          simpleAlert(
            storesDispatch,
            "ERROR",
            err.response.data ? err.response.data.msg : err.code,
          );
        });
    }
  };

  useEffect(() => {
    getHqBranchCombo();
  }, [modalParam]);

  const onCheckPhone = () => {
    if (phone1.length === 3 && phone2.length >= 3 && phone3.length === 4) {
      HttpInstance.get(process.env.REACT_APP_USER_SERVER + "/member/check_phone", {
        params: {
          phone: phone1 + "-" + phone2 + "-" + phone3,
        },
      })
        .then((res) => {
          if (!restEmpty(res.data.data)) {
            // console.log(res);
            const isDuplicate = res.data.data;
            // console.log(res.data.data);
            if (isDuplicate === "N") {
              setPhoneCheckStatus("Y");
              // baseInfoState.phone = phone1 + "-" + phone2 + "-" + phone3;
              setMemberInfo((cur) => {
                const obj = _.cloneDeep(memberInfo);
                obj.base_info.phone = phone1 + "-" + phone2 + "-" + phone3;
                return obj;
              });
            } else {
              setPhoneCheckStatus("N");
              // baseInfoState.phone = "";
            }
          }
        })
        .catch((err) => {
          console.log("err");
          simpleAlert(
            storesDispatch,
            "ERROR",
            err.response.data ? err.response.data.msg : err.code,
          );
        });
    } else {
      memberInfo.base_info.phone = "";
      setPhoneCheckStatus("");
    }

    setPhone1(phone1);
    setPhone2(phone2);
    setPhone3(phone3);
  };

  const checkDuplMember = () => {
    // 권한이 있는 지점의 ID 리스트. 중복자가 권한 없는 지점 회원인 경우 지점변경으로 진입하도록 유도하기 위함
    const availBranchIdList = [];
    for (let i = 0; i < hqBranchData.target_list.length; i++) {
      for (let j = 0; j < hqBranchData.target_list[i].branch_list.length; j++) {
        availBranchIdList.push(hqBranchData.target_list[i].branch_list[j].branch_id);
      }
    }

    const param = {
      phone: phone1 + "-" + phone2 + "-" + phone3,
      branch_info: memberInfo.branch_info,
      is_assign: true,
      avail_branch_list: availBranchIdList,
    };
    setModalInfo({
      show: true,
      title: "연락처 중복 확인",
      Content: <RegisterPhoneCheckModal modalParam={param} onModalDone={onDuplModalDone} />,
      callback: null,
      Buttons: undefined,
    });
  };

  const onDuplModalDone = (param1, prevMemberId, phone) => {
    setRemovePhoneMemberId(prevMemberId);
    setPhoneCheckStatus("Y");
    memberInfo.base_info.phone = phone1 + "-" + phone2 + "-" + phone3;
    viewModelRef.current.setClose();
    if (param1 === "cancel") {
      onModalDone(param1);
    }
  };

  // 주소 API 설정 감지
  useEffect(() => {
    const docRef = doc(db, "deploy", "address");

    const unsubscribe = onSnapshot(
      docRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const { isChangeJusoApi } = docSnapshot.data();
          setIsUseJusoApi(isChangeJusoApi);
        }
      },
      (err) => {
        console.log("주소 API 설정 에러:", err.code, err.message);
      },
    );

    return () => unsubscribe();
  }, []);

  return (
    <div style={{ width: "50rem" }}>
      {loading && <Loading />}
      <ModalPopupLocal ref={viewModelRef} params={modalInfo} />

      {/* 🆕 주소 검색 모달 추가 */}
      {isUseJusoApi ? (
        <AddressSearchModal
          isOpen={isAddrPopup}
          onClose={() => setAddrPopup(false)}
          onSelect={handleJusoSelect}
        />
      ) : (
        <Popup
          isOpen={isAddrPopup}
          onClose={() => openAddrPopup(false)}
          title="주소 검색"
          Content={
            <DaumPostcode
              onComplete={handleComplete}
              autoClose={false}
              style={{ width: "30rem", height: "35rem" }}
            />
          }
        />
      )}

      <div style={{ display: "flex" }}>
        <IconButton type="border" />
        <div style={{ width: "0.5rem" }}></div>
        <SubTitle titleText="가입 정보" />
      </div>
      <div style={{ display: "flex" }}>
        <ComboBox
          marginLeft="1.5rem"
          labelWidth={labelWidth}
          comboItemWidth={compWidth}
          labelText="본부"
          data={hqBranchData.hq_list}
          defaultValue={hqBranchData.hq_list[hqIdx]}
          onChangeCallback={(e) => {
            const hIdx = hqBranchData.hq_list.findIndex((el) => el === e.target.value);
            if (hIdx !== -1) {
              setHqIdx(hIdx);
            }
            setMemberInfo((cur) => {
              const obj = { ...cur };
              obj.hq_info = hqBranchData.target_list[hIdx].hq_info;
              obj.branch_info = { branch_id: "", branch_name: "" };

              setSearchParam((prev) => ({
                ...prev,
                hq_info: obj.hq_info,
              }));
              return obj;
            });
          }}
        />
        <SearchComboBox
          marginLeft="1.5rem"
          labelWidth={labelWidth}
          comboItemWidth={compWidth}
          labelText="지점"
          data={hqBranchData.branch_list[hqIdx]}
          defaultValue={hqBranchData.branch_list[hqIdx][0]}
          onChangeCallback={(e, v, idx) => {
            setMemberInfo((cur) => {
              const obj = { ...cur };
              obj.branch_info = hqBranchData.target_list[hqIdx].branch_list[idx];
              setSearchParam((prev) => ({
                ...prev,
                branch_info: obj.branch_info,
              }));
              return obj;
            });
            // 지점 변경 시 CS 직원 목록 다시 가져오기
            getBranchCsStaffList(hqBranchData.target_list[hqIdx].branch_list[idx].branch_id);
          }}
        />
        <ComboBox
          required
          marginLeft="1.5rem"
          labelWidth={labelWidth}
          comboItemWidth={compWidth}
          labelText="가입 경로"
          data={["기타", "소개", "간판", "블로그", "인스타", "페이스북", "네이버", "홍보"]}
          onChangeCallback={(e) => {
            memberInfo.base_info.reg_path = e.target.value;
          }}
        />
      </div>

      <div style={{ display: "flex" }}>
        <IconButton type="border" />
        <div style={{ width: "0.5rem" }}></div>
        <SubTitle titleText="회원 정보" />
      </div>
      <div>
        <div style={{ display: "flex" }}>
          <TextField
            required
            marginLeft="1.5rem"
            labelWidth={labelWidth}
            textBoxWidth={compWidth}
            labelText="이름"
            onChangeCallback={(e) => {
              memberInfo.member_info.member_name = e;
            }}
          />
          <DatePicker
            required
            labelMarginLeft="1.5rem"
            labelText="생년월일"
            labelWidth={labelWidth}
            minWidth={compWidth}
            maxDate={getCurrentDate()}
            onChangeCallback={(e) => {
              const ageGroup = calculateAgeGroup(e); // 연령대 자동 계산
              setMemberInfo((cur) => {
                const obj = { ...cur };
                obj.base_info.birth = e;
                obj.base_info.ages = ageGroup; // 연령대 자동 설정
                return obj;
              });
            }}
          />
          {/* <ComboBox
            required
            marginLeft="1.5rem"
            labelWidth={labelWidth}
            comboItemWidth={compWidth}
            labelText="연령대"
            data={["10~20대", "30대", "40대", "50대 이상"]}
            onChangeCallback={(e) => {
              memberInfo.base_info.ages = e.target.value;
            }}
          /> */}
          <ComboBox
            required
            marginLeft="1.5rem"
            labelWidth={labelWidth}
            comboItemWidth={compWidth}
            labelText="성별"
            defaultValue={""}
            data={["남", "여"]}
            onChangeCallback={(e) => {
              memberInfo.base_info.gender = e.target.value;
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            marginTop: "0.7rem",
            // justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TextField
            required
            inputRef={phoneRef1}
            marginLeft="1.5rem"
            textMarginRight="0rem"
            labelWidth={labelWidth}
            textBoxWidth={"4.5rem"}
            labelText="연락처"
            maxLength={3}
            isStringNumber
            onChangeCallback={(e) => {
              phone1 = e;
              onCheckPhone();
              if (e.length === 3) {
                phoneRef2.current.select();
              }
            }}
          />
          <TextField
            inputRef={phoneRef2}
            required
            textMarginRight="0rem"
            labelWidth="0.1rem"
            labelMarginLeft="0.25rem"
            labelText="-"
            maxLength={4}
            textBoxWidth={"4.5rem"}
            isStringNumber
            onChangeCallback={(e) => {
              phone2 = e;
              onCheckPhone();
              if (e.length === 4) {
                phoneRef3.current.select();
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Backspace" && !phone2) {
                phoneRef1.current.select();
              }
            }}
          />
          <TextField
            inputRef={phoneRef3}
            required
            labelWidth="0.1rem"
            textMarginRight="0.5rem"
            labelMarginLeft="0.25rem"
            labelText="-"
            maxLength={4}
            textBoxWidth={"4.5rem"}
            isStringNumber
            onChangeCallback={(e) => {
              phone3 = e;
              onCheckPhone();
            }}
            onKeyDown={(e) => {
              if (e.key === "Backspace" && !phone3) {
                phoneRef2.current.select();
              }
            }}
            // onBlur={() => onCheckPhone()}
          />
          {phoneCheckStatus === "Y" ? (
            <img
              alt="O"
              src={successIcon}
              style={{
                display: "flex",
                width: "1.4rem",
                height: "1.4rem",
                marginRight: "0.5rem",
              }}
            />
          ) : phoneCheckStatus === "N" ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                alt="O"
                src={failIcon}
                style={{
                  display: "flex",
                  width: "1.4rem",
                  height: "1.4rem",
                  marginRight: "0.5rem",
                }}
              />
              <NormalBtn
                theme="white"
                width="6.5rem"
                name="중복자 확인"
                onClick={() => {
                  checkDuplMember();
                }}
              />
            </div>
          ) : (
            <></>
          )}
          <ComboBox
            required
            marginLeft="1.5rem"
            labelWidth={labelWidth}
            comboItemWidth={compWidth}
            labelText="상담자"
            data={csStaffState.cs_team_name_list}
            onChangeCallback={(e) => {
              const index = csStaffState.cs_team_name_list
                .map((item) => item)
                .indexOf(e.target.value);
              if (index !== -1) {
                setMemberInfo((cur) => {
                  const obj = _.cloneDeep(cur);
                  obj.cs_staff_info = {
                    staff_id: csStaffState.cs_team_list.team[index].staff_id,
                    staff_name: csStaffState.cs_team_list.team[index].staff_name,
                    sabun: csStaffState.cs_team_list.team[index].sabun,
                    staff_pos: csStaffState.cs_team_list.team[index].position.org_name,
                    staff_rank: csStaffState.cs_team_list.team[index].rank.org_name,
                  };
                  return obj;
                });
              }
            }}
          />
          {/* 개인정보 활용 및 마케팅 수신 동의 체크 */}
          {/* <div style={{ display: "flex", marginLeft: "auto" }}>
            <CheckBox
              marginTop="0rem"
              labelText="개인정보 활용 동의"
              ItemMarginLeft={"1.5rem"}
              onChangeCallback={(e) => {
                setMemberInfo((cur) => {
                  const obj = { ...cur };
                  obj.base_info.agree_personal = e.checked;
                  return obj;
                });
              }}
            />
            <CheckBox
              marginTop="0rem"
              labelText="마케팅 수신 동의"
              onChangeCallback={(e) => {
                setMemberInfo((cur) => {
                  const obj = { ...cur };
                  obj.base_info.agree_marketing = e.checked;
                  return obj;
                });
              }}
            />
          </div> */}
        </div>
        <div style={{ display: "flex", marginTop: "0.7rem" }}>
          <TextField
            marginLeft="1.5rem"
            textMarginRight="0rem"
            labelWidth={labelWidth}
            textBoxWidth={"20rem"}
            labelText="주소"
            defaultValue={memberInfo.base_info.address_1}
            disabled
          />
          <TextField
            marginLeft="0rem"
            textBoxWidth={"20rem"}
            onChangeCallback={(e) => {
              memberInfo.base_info.address_2 = e;
            }}
          />
          <IconButton
            type="search"
            onClick={() => {
              openAddrPopup(true);
            }}
          />
        </div>
        <div style={{ display: "flex", marginTop: "0.7rem" }}>
          <TextField
            marginLeft="1.5rem"
            labelWidth={labelWidth}
            textBoxWidth={"43.5rem"}
            labelText="특이사항"
            onChangeCallback={(e) => {
              memberInfo.base_info.remarks = e;
            }}
          />
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
        <NormalBtn
          name="등록"
          onClick={() => {
            validationCheck();
          }}
        />
      </div>
    </div>
  );
};
export default AssignNewbie;
